export const IndicatorColorFilter = () => indicator => {
  let orange = 'rgba(246,139,31,1)';
  let red = 'rgba(158,11,15,1)';
  let output = indicator.color;
  if (!isNaN(indicator.value) && indicator.hasThresholds && !isNaN(indicator.minThreshold) && !isNaN(indicator.maxThreshold)) {
    if (indicator.value >= indicator.maxThreshold) {
      output = indicator.maxThresholdColor || red;
    } else if (indicator.value >= indicator.minThreshold) {
      output = indicator.minThresholdColor || orange;
    }
  } else if (
    typeof indicator.value === 'string' &&
    indicator.value.indexOf('%') !== -1 &&
    indicator.hasThresholds &&
    !isNaN(indicator.minThreshold) &&
    !isNaN(indicator.maxThreshold)
  ) {
    let value = parseFloat(indicator.value.slice(0, -1));
    if (value >= indicator.maxThreshold) {
      output = indicator.maxThresholdColor || red;
    } else if (value >= indicator.minThreshold) {
      output = indicator.minThresholdColor || orange;
    }
  }
  return output;
};

export default 'indicatorColor';
